import React, { Component } from "react";
import axios from "axios";

import Alert from "../../commons/components/Alert";
import CS from "../../commons/services/Common";
import VS from "../../commons/services/Validation";
import { withTranslation } from "react-i18next";
import { LabelWidthClass } from "./translationUiConst";
// import SseTest from "./SseTest.jsx";

/**
 * 마이페이지 컴포넌트
 */
class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      account: {},
      cst: {},
      email1: "",
      email2: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.getItem();
  }

  async getItem() {
    let res = await axios.get(`/cst/api/myinfo`);
    if (typeof res != "undefined") {
      let email = res.data.account.email;
      if (email.indexOf("@") > -1) {
        this.setState({
          email1: email.split("@")[0],
          email2: email.split("@")[1],
        });
      }
      this.setState({
        account: res.data.account,
        cst: res.data.constructor,
      });
    }
  }

  async handleSubmit(e) {
    const { t } = this.props;
    e.preventDefault();
    const data = new FormData(e.target);
    let id = data.get("id");
    let pw = data.get("pw");
    let pw1 = data.get("pw1");
    let pw2 = data.get("pw2");
    let checkResult = await axios.post(`/api/account/current-password-check`, {
      id: id,
      password: pw,
    });

    if (checkResult.data.result) {
      if (!VS.isValidPasswd(pw1)) {
        document.getElementById("pw1").focus();
        return;
      }
      if (!VS.isValidPasswd(pw2)) {
        document.getElementById("pw2").focus();
        return;
      }

      if (pw1 !== pw2) {
        CS.notification("warning", t('key521')); // 비밀번호가 일치하지 않습니다.
        return;
      } else {
        let email = data.get("mail1") + "@" + data.get("mail2");
        if (!VS.isValidEmail(email)) {
          document.getElementById("mail2").focus();
          return;
        }
        const result = await CS.update("/api/account/password-change", {
          id: id,
          oldPassword: pw,
          password: pw1,
          email: email,
        });
        if (result.isSuccess) {
          window.location.href = "/plant-status/main";
        }
      }
    } else {
      CS.notification("warning", t("key522")); // 현재 비밀번호가 올바르지 않습니다.
      document.getElementById("pw").focus();
      //this.controlModal(true);
    }
  }

  controlModal = (isShow) => {
    this.setState({
      isShow: isShow,
    });
  };

  render() {
    const { isShow, account, cst, email1, email2 } = this.state;
    const { t, i18n } = this.props;
    return (
      <>
        <Alert
          show={isShow}
          handler={this.controlModal}
          comment={t("key520")} // 비밀번호가 맞지 않아<br/>변경이 불가합니다.
        />
        <div className="page-tit gray">
          <div className="container">
            <h2 className="tit">{t('key62')}</h2>
          </div>
        </div>
        {/*<SseTest/>*/}
        <div className="container">
          <form onSubmit={this.handleSubmit}>
            <input type="hidden" id="id" name="id" defaultValue={account.id} />
            <h3 className="content-tit1">{t('key63')}</h3>
            <div className="card2">
              <div className="f-stack form-view">
                <div>
                  <span className="tit">{t('key64')}</span>
                  <strong>{cst.constructorName}</strong>
                </div>
                <div>
                  <span className="tit">{t('key65')}</span>
                  <strong>{account.phone}</strong>
                </div>
                <div>
                  <span className="tit">{t('key66')}</span>
                  {cst.fileId != null ? (
                    <button
                      type="button"
                      className="btn white w210 radius15 ellipsis"
                      onClick={() => CS.fileDown(cst.fileId)}
                    >
                      {t('key68')}
                    </button>
                  ) : (
                    <p className="btn white w210 radius15 ellipsis">
                      {t('key67')}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <h3 className="content-tit1">{t('key69')}</h3>
            <div className="card2">
              <div className="form-inline3">
                <div className="form-group">
                  <label className={`tit ${LabelWidthClass(i18n)}`}>{t('key70')}</label>
                  <div className="text-box w220">{account.userId}</div>
                </div>
                <div className="form-group">
                  <label htmlFor="pw1" className={`tit ${LabelWidthClass(i18n)}`}>
                    {t('key71')}
                  </label>
                  <input
                    type="password"
                    id="pw"
                    name="pw"
                    className="w220"
                    defaultValue=""
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="pw2" className={`tit ${LabelWidthClass(i18n)}`}>
                    {t('key72')}
                  </label>
                  <input
                    type="password"
                    id="pw1"
                    name="pw1"
                    className="w220"
                    defaultValue=""
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="pw3" className={`tit ${LabelWidthClass(i18n)}`}>
                    {t('key73')}
                  </label>
                  <input
                    type="password"
                    id="pw2"
                    name="pw2"
                    className="w220"
                    defaultValue=""
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mail1" className={`tit ${LabelWidthClass(i18n)}`}>
                    {t('key74')}
                  </label>
                  <input
                    type="text"
                    id="mail1"
                    name="mail1"
                    className="w220"
                    defaultValue={email1}
                  />
                  <span className="mail-unit">@</span>
                  <input
                    type="text"
                    id="mail2"
                    name="mail2"
                    className="w220"
                    defaultValue={email2}
                  />
                </div>
              </div>
            </div>
            <div className="btn-areaC2">
              <button type="submit" className="btn primary">
                {t('key76')}
              </button>
            </div>
          </form>
        </div>
      </>
    );
  }
}

export default withTranslation()(Main);
